module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ser",
    staticStyle: {
      "margin-top": "25%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page11",
      "id": "rps11",
      "src": "Images/page-11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h0",
    attrs: {
      "id": "d7e42011"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_toc_r1#d7e1606"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C75334"
    }
  }, [_vm._v("THE HOME"), _c('br'), _vm._v("THAT"), _c('br'), _vm._v("WELCOMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "rps11a"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page11",
      "src": "Images/page-11.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-401a89de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Susa_ISBN9781588169167_epub_part01_r1.vue
// module id = 78
// module chunks = 0